import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v18h22V3zm-2 16H3v-3h18v3z"
}), 'CallToActionSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallToActionSharp.js
// module id = 2630
// module chunks = 2